import { MarketHechoBody } from './marketHechoBody.class';

export class MarketHecho {
  symbol: string;
  body: MarketHechoBody;
  benchmarks: any[];
  closePrice: number;
}
